import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { requestAllPoems } from '../../_actions/PoemsActions';
import { TOCData } from '../../_selectors/selectors';
import './TableOfContents.scss';

/* TableOfContents */
const TableOfContents = (props) => {
  // eslint-disable-next-line no-shadow
  const { tocData, requestAllPoems } = props;

  const sectionTitles = {
    spleenEtIdeal: 'Spleen Et Idéal',
    tableauxParisiens: 'Tableaux Parisiens',
    leVin: 'Le Vin',
    fleursDuMal: 'Fleurs Du Mal',
    revolte: 'Révolte',
    laMort: 'La Mort',
  };

  useEffect(() => {
    if (tocData.length === 0) requestAllPoems();
  }, [requestAllPoems, tocData]);

  const generateLinks = () => {
    const toc = tocData.map((item, idx) => {
      if (idx > 0 && item.poemSection !== tocData[idx - 1].poemSection) {
        return (
          <React.Fragment key={item.poemId}>
            <h3 className="section-title">{sectionTitles[item.poemSection]}</h3>
            <li>
              <Link to={`/poems/${item.poemId}`}>
                <span className="toc-numeral">{item.poemNumber}</span>
                <span className="toc-title">
                  {item.poemTitleTOC || item.poemTitle}
                </span>
                <span className="toc-title-french">{item.poemTitleFrench}</span>
              </Link>
            </li>
          </React.Fragment>
        );
      }
      return (
        <li key={item.poemId}>
          <Link to={`/poems/${item.poemId}`}>
            <span className="toc-numeral">{item.poemNumber}</span>
            <span className="toc-title">
              {item.poemTitleTOC || item.poemTitle}
            </span>
            <span className="toc-title-french">{item.poemTitleFrench}</span>
          </Link>
        </li>
      );
    });

    if (toc.length > 0) {
      // TODO: Either this should be front-loaded or a message that content
      // is loading should appear here.
      toc.push(
        <React.Fragment key="afterword">
          <Link to="/afterword">
            <h3 className="section-title">Afterword</h3>
          </Link>
        </React.Fragment>,
      );
    }

    return toc;
  };

  return (
    <div className="table-of-contents">
      <h2>Table of Contents</h2>
      <ul>{generateLinks()}</ul>
    </div>
  );
};

TableOfContents.propTypes = {
  tocData: PropTypes.arrayOf(PropTypes.object),
  requestAllPoems: PropTypes.func.isRequired,
};

TableOfContents.defaultProps = {
  tocData: [],
};
/* */

function mapStateToProps(state) {
  return {
    tocData: TOCData(state),
  };
}

export default connect(
  mapStateToProps,
  { requestAllPoems }
)(TableOfContents);
